import { render, staticRenderFns } from "./JabatanPengurus.vue?vue&type=template&id=f43ad646"
import script from "./JabatanPengurus.vue?vue&type=script&lang=js"
export * from "./JabatanPengurus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports